import { useState, useEffect } from 'react';
import { CardMediaProps } from '@mui/material';
import MissingImage from 'components/MissingImage';
import { StyledCardMedia, SpinnerWrapper, Spinner } from './ImageWithLoader.styles';

interface ImageWithLoaderProps extends CardMediaProps {
  src?: string;
  alt?: string;
}

const ImageWithLoader = ({ src, ...rest }: ImageWithLoaderProps) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    if (src) {
      const newImage: HTMLImageElement = new Image();
      newImage.src = src;
      newImage.onload = () => setImage(newImage);
      newImage.onerror = () => setHasError(true);
    }
  }, [src]);

  if (!src || hasError) {
    return <MissingImage />;
  }

  if (!image) {
    return (
      <SpinnerWrapper aria-label="Image Loader">
        <Spinner />
      </SpinnerWrapper>
    );
  }

  return <StyledCardMedia component="img" image={image.src} {...rest} />;
};

export default ImageWithLoader;
